import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OutrosDocumentosUploadPage } from './outros-documentos-upload.page';

const routes: Routes = [
  { path: '', component: OutrosDocumentosUploadPage },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OutrosDocumentosUploadRoutingModule { }
